import styled from 'styled-components';
import { colors } from '../../styles';
import PrimaryButton from './primary-button';

export default styled(PrimaryButton)`
  background: ${colors.red500};
  border: 1px solid ${colors.red700};
  color: ${colors.white};

  :hover {
    background: ${colors.red300};
    border: 1px solid ${colors.red500};
    box-shadow: 0 4px 6px 0 rgba(229, 56, 45, 0.15);
    color: white;
  }
`;
